<template>
    <div>
      <!-- 面包屑导航 -->
      <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>钱包管理</el-breadcrumb-item>
      </el-breadcrumb> -->
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="用户名">
          <el-input size="small" v-model="formInline.user" placeholder="输入用户"></el-input>
        </el-form-item>
        <el-form-item label="c2c订单id">
          <el-input size="small" v-model="formInline.orderId" placeholder="输入c2c订单id"></el-input>
        </el-form-item>
        <el-form-item label="买卖方向">
          <el-select size="small" v-model="formInline.direct" placeholder="请选择">
            <el-option v-for="item in typeToken" :label="item.key" :value="item.value" :key="item.value"></el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="订单状态">
          <el-select size="small" v-model="formInline.orderStatus" placeholder="请选择">
            <el-option v-for="item in typeToken1" :label="item.key" :value="item.value" :key="item.value"></el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="时间">
        <el-date-picker
        size="small"
        v-model="timeVal"
        value-format="yyyy-MM-dd"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
      <!--列表-->
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <!-- show-summary -->
        
        <el-table-column align="center" prop="userName" label="用户名" >
        </el-table-column>
        <el-table-column align="center" prop="orderId" label="c2c订单id" >
        </el-table-column>
        <el-table-column align="center" prop="dealVol" label="成交数量" >
        </el-table-column>
        <el-table-column align="center" prop="publishVol" label="发布数量" >
        </el-table-column>
        <el-table-column align="center" prop="remainVol" label="剩余数量" >
        </el-table-column>
        <el-table-column align="center" prop="exchangeVol" label="兑换数量" >
        </el-table-column>
        <el-table-column align="center" prop="avgDealPrice" label="成交均价" >
        </el-table-column>
        <el-table-column align="center" prop="dealOrderCount" label="成交单数" >
        </el-table-column>
        <!-- <el-table-column align="center" prop="orderStatus" label="订单状态" >
        </el-table-column> -->
        <el-table-column align="center" label="订单状态" min-width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.orderStatus == 'waiting'">等待订单确认</div>
            <div v-if="scope.row.orderStatus == 'ongoing'">等待撮合</div>
            <div v-if="scope.row.orderStatus == 'complete'">已完成</div>
            <div v-if="scope.row.orderStatus == 'failed'">失败</div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="direct" label="买卖方向" >
          <template slot-scope="scope">
              <p>{{ scope.row.direct == 'BUY'?'买':'卖' }}</p>
        </template>
        </el-table-column>
        <!-- <el-table-column align="center" prop="baseCoinName" label="基币" >
        </el-table-column>
        <el-table-column align="center" prop="coinName" label="对币" >
        </el-table-column> -->
        <el-table-column align="center" prop="txId" label="txId" >
          <template slot-scope="scope">
          <div v-if="scope.row.txId != ''"><el-link icon="el-icon-link" type="primary" :underline="false" :title="scope.row.txId" :href="scope.row.url" target="_blank">{{ scope.row.txId.slice(0,6)+'……'+scope.row.txId.substr(scope.row.txId.length-6,6) }}</el-link></div>
          <div v-else>无</div>
        </template>
        </el-table-column>
        <el-table-column align="center" prop="setupTime" label="创建时间" >
        </el-table-column>
        
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
  </template>
  
  <script>
  import { c2cOrders } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        // rules表单验证
        formInline: {
          from: 1,
          limit: 10,
          startTime: "",
          endTime: "",
          "user": "",
          "orderId": "",
          "direct": "",
          "orderStatus": ""
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        timeVal:"",
        typeToken: [
          { key: '请选择', value: '' },
          { key: '买', value: 'BUY' },
          { key: '卖', value: 'SELL' },
        ],
        typeToken1: [
          { key: '请选择', value: '' },
          { key: '等待订单确认', value: 'waiting' },
          { key: '等待撮合', value: 'ongoing' },
          { key: '已完成', value: 'complete' },
          { key: '失败', value: 'failed' },
        ],
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */
  
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },
  
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取转入列表
      getdata(parameter) {
        this.loading = true
        c2cOrders(parameter)
          .then(res => {
            this.loading = false
            if (res.code != 0) {
              this.$message({
                type: 'info',
                message: res.message
              })
            } else {
              this.listData = res.data.list
              // 分页赋值
              // this.pageparm.currentPage = this.formInline.from
              // this.pageparm.pageSize = this.formInline.limit
              this.pageparm.total = res.data.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('列表加载失败，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.pageparm.pageSize = parm.pageSize
        this.formInline.from = (parm.currentPage-1)*(this.pageparm.pageSize) + 1
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.pageparm.currentPage = 1
        this.formInline.from = 1
        console.log(this.timeVal)
        if(this.timeVal instanceof Array){
          this.formInline.startTime = this.timeVal[0]+' 00:00:00'
          this.formInline.endTime = this.timeVal[1]+' 23:59:59'
        }else{
          this.formInline.startTime = ''
          this.formInline.endTime = ''
        }
        this.getdata(this.formInline)
      }
    }
  }
  </script>
  
  <style scoped>
  .user-search {
    margin-top: 20px;
  }
  .userRole {
    width: 100%;
  }
  </style>
  
   
   


// WEBPACK FOOTER //
// src/views/c2c/order.vue